import { render, staticRenderFns } from "./simOpenXy.vue?vue&type=template&id=499b1355&scoped=true&"
import script from "./simOpenXy.vue?vue&type=script&lang=js&"
export * from "./simOpenXy.vue?vue&type=script&lang=js&"
import style0 from "./simOpenXy.vue?vue&type=style&index=0&id=499b1355&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b1355",
  null
  
)

export default component.exports